import { useHistory } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Button, Stack, Typography } from "@mui/material";

import HomePageCard from "../HomePageCard";
import { useZendeskTickets } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TicketRow } from "../Rows/TicketRow";

export const RecentInquiriesCard = () => {
  const { tickets, loading } = useZendeskTickets();

  const history = useHistory();

  if (loading) {
    return <LoadingCard title="Recent expert inquiries" />;
  }

  const displayedTickets = tickets.slice(0, 2);

  return (
    <HomePageCard title="Recent expert inquiries">
      <Stack sx={{ height: 161, p: 3, pt: 2 }} justifyContent="space-between">
        {displayedTickets.map((zendeskTicket, index) => (
          <TicketRow
            key={zendeskTicket.ticket.id}
            zendeskTicket={zendeskTicket}
            isLastItem={index === displayedTickets.length - 1}
          />
        ))}
        {tickets.length === 0 && (
          <Typography variant="body2" color="text.secondary" pt={1}>
            No expert inquiries yet
          </Typography>
        )}
        <Button
          variant="outlined"
          size="small"
          data-cy="cloud-waste-insights-btn"
          endIcon={<ArrowForward />}
          sx={{ mt: 1, width: "fit-content" }}
          onClick={() => {
            history.push("./support?open-case-iq=true");
          }}
        >
          Expert inquiry
        </Button>
      </Stack>
    </HomePageCard>
  );
};
